import {FC} from 'react'
import {downloadTemplateCamp, uploadMasiveCamp} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'

const FormMasiveUpload: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const response = await uploadMasiveCamp(formData) // Use the service to upload the file
      return response
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateCamp}
      handleSendService={handleUpload}
      title='Campamento'
    />
  )
}

export {FormMasiveUpload}
